import { useContext } from 'react'

import { SafeAreaContext } from './safe-area-context'

export function useSafeArea() {
  return useContext(SafeAreaContext)
}
